// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__pjRjQ","list":"styles_list__2aaxY"};